import { useContext, useEffect, useState } from 'react';
import Layout from '../../Component/layout/main-layout';
import { useTranslation } from 'react-i18next';
import { Get } from '../../api/services/api_helpers';
import { Context } from '../../Store/context';
import Loading from '../../Component/loader/loader';
import { Link } from 'react-router-dom';
import pdf from '../../Images/icons/pdfdownload.svg';
import layoutBgImg from '../../Images/layout/others.jpg'
import GlobalLayout from '../../Component/layout/global-layout';
import searchImg from '../../Images/search.png'

const Search = () => {
    const { t, i18n } = useTranslation();
    const [search, setSearch] = useState('');
    const [searchResults, setSearchResults] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const { showError } = useContext(Context);
    const [recommendations, setRecommendations] = useState([]);
    const [recommendationLoading, setRecommendationLoading] = useState(false)
    const [showRecommendations, setShowRecommendations] = useState(true);
    const [isLogoVisible, setIsLogoVisible] = useState(true);

    const handleSearchClick = async (e) => {
        e.preventDefault();
        setShowRecommendations(false);
        setIsLogoVisible(false);
        if (!search) return;
        setIsLoading(true);
        try {
            const data = await Get(`search/?q=${search}`);
            setSearchResults(data);
        } catch (error) {
            showError(error.message);
        } finally {
            setIsLoading(false);
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') {
            handleSearchClick(e);
        }
    };

    useEffect(() => {
        if (!search.trim()) {
            setRecommendations([]);
            setSearchResults([]);
            setShowRecommendations(true);
            setIsLogoVisible(true);
            return;
        }
        const fetchData = async () => {
            setRecommendationLoading(true);
            try {
                const data = await Get(`search/?q=${search}`);
                setRecommendations(data.slice(0, 10));
            } catch (error) {
                showError(error.message);
            } finally {
                setRecommendationLoading(false);
            }
        };

        fetchData();
    }, [search, showError]);

    const getLawName = (law) => {
        const currentLang = i18n.language;
        return currentLang === 'ru' ? law.rus_name :
            currentLang === 'en' ? law.eng_name : law.tm_name;
    };

    const getPdfUrl = (law) => {
        const currentLang = i18n.language;
        return currentLang === 'ru' ? law.rus_pdf :
            currentLang === 'en' ? law.eng_pdf : law.tm_pdf;
    };

    return (
        <GlobalLayout
            title={`${t('search')} - ${t('supreme_court')} ${t('turkmenistan')}`}
            keywords="Gozleg, Gözleg, Hukuk näme, Kanunlar, Kodeksler, Hukuk, Kazyyet"
        >
            <div className='mb-20'>
                <Layout
                    title={t('search')}
                    layoutBgImg={layoutBgImg}
                />
                <div className='media'>
                    <div className='bg-white dark:bg-dark-box
                                    rounded-md mt-8 p-4 xl:p-8'>
                        <section className='w-full flex justify-center mb-8'>
                            <div className='relative w-full xl:w-[30%]'>
                                <div className='flex'>
                                    <div className='transition border border-border rounded-l-md
                                                    dark:border-dark-border dark:bg-dark-box                                                
                                                    duration-150 ease-in-out shadow-inner w-full'>
                                        <input
                                            type="search"
                                            placeholder={t('search')}
                                            className='dark:text-white p-2 w-full focus:outline-none     
                                                       border-none rounded-l-md dark:bg-dark-box'
                                            value={search}
                                            onChange={(e) => setSearch(e.target.value)}
                                            onKeyDown={handleKeyDown}
                                        />
                                    </div>
                                    <button
                                        onClick={handleSearchClick}
                                        className='p-2 bg-primary text-white rounded-r-md 
                                                   transition duration-150 ease-in-out 
                                                   focus:outline-none focus:ring-2 
                                                   focus:ring-indigo-500'
                                    >
                                        {t('search')}
                                    </button>
                                </div>

                                {/* Recommendation table  */}
                                {showRecommendations && recommendations?.length > 0 &&
                                    <ul className='bg-white rounded-b-md shadow-lg border border-secondary
                                                   dark:border-none dark:bg-dark-box max-h-[300px] w-full
                                                   overflow-y-scroll absolute mt-[-3px] z-[1]'>
                                        {recommendationLoading ? (
                                            <Loading />) : <>
                                            <li className='p-2 flex justify-between dark:text-white bg-gray
                                                         border-b border-b-border dark:bg-dark-box dark:border-b
                                                         dark:border-b-border'>
                                                {t('search_result')}
                                                <p>{recommendations?.length}</p>
                                            </li>
                                            {recommendations?.map((r) => (
                                                <li className='p-2 flex justify-between border-b border-b-secondary 
                                                     w-full items-center dark:border-b-dark-box dark:text-dark-text'>
                                                    <Link to={`/laws/${r.id}`} className='w-[90%]'>
                                                        <p>
                                                            {getLawName(r)}
                                                        </p>
                                                    </Link>
                                                    <a
                                                        href={getPdfUrl(r)}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className='flex justify-end w-6 h-6'
                                                    >
                                                        <img src={pdf} alt="PDF" className='w-full h-full' />
                                                    </a>
                                                </li>
                                            ))}
                                            {recommendations?.length >= 10 &&
                                                <li
                                                    onClick={handleSearchClick}
                                                    className='w-full p-2 bg-blue dark:text-dark-text
                                                              cursor-pointer text-center dark:bg-dark-border'>
                                                    {t('view_all')}
                                                </li>
                                            }
                                        </>}
                                    </ul>
                                }
                            </div>
                        </section>

                        {isLogoVisible ? (
                            <div className="flex justify-center mt-10">
                                <img src={searchImg} alt="Logo" className="w-1/4 grayscale" />
                            </div>
                        ) :
                            <>
                                {/* Search result */}
                                {isLoading ? <Loading /> :
                                    <>
                                        {searchResults.length > 0 ? (
                                            <>
                                                <p className='text-lg md:text-xl font-bold flex gap-1 
                                                              items-center  dark:text-dark-text'>
                                                    {t('search_result')}
                                                    <span className='flex gap-1'>
                                                        (
                                                        {searchResults.length}
                                                        <p>{t('info')}</p>
                                                        )
                                                    </span>
                                                </p>

                                                <ul>
                                                    {searchResults?.map((law) => (
                                                        <li key={law.id}
                                                            className='bg-gray dark:bg-dark dark:text-dark-text 
                                                                       flex justify-between items-center p-4 mt-4'>
                                                            <Link to={`/search-law/?id=${law.id}`} className='w-[90%]'>
                                                                <p>{getLawName(law)}</p>
                                                            </Link>
                                                            <a
                                                                href={getPdfUrl(law)}
                                                                target="_blank"
                                                                rel="noopener noreferrer"
                                                                className='flex justify-end w-8 h-8'
                                                            >
                                                                <img
                                                                    src={pdf}
                                                                    alt="Download PDF"
                                                                    width='32'
                                                                    className='w-full h-full'
                                                                />
                                                            </a>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </>
                                        ) : (
                                            <p className='dark:text-dark-text'>{t('nothing_found')}</p>
                                        )}
                                    </>
                                }
                            </>
                        }
                    </div>
                </div>
            </div>
        </GlobalLayout>
    );
}

export default Search;
